import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Works } from "@/components/site/Works";
import { ComeFunziona } from "@/components/site/ComeFunziona";
import { Services } from "@/components/site/Services";
import { Faq } from "@/components/site/Faq";
import { Contacts } from "@/components/site/Contacts";
import { Footer } from "@/components/site/Footer";
import { QuoteModal } from "@/components/site/QuoteModal";
import { B2BQuoteModal } from "@/components/site/B2BQuoteModal";
import { CookieBanner } from "@/components/site/CookieBanner";
import { ChatWidget } from "@/components/site/ChatWidget";
import { Reveal } from "@/components/site/Reveal";
import Privacy from "@/components/site/Privacy";
import { CONTACTS } from "@/components/site/data";
import { MessageCircle } from "lucide-react";

const HomePage = () => (
  <>
    <Header />
    <main>
      <Hero />
      <Marquee />
      <section data-testid="brand-strip" className="py-16 sm:py-20 px-6 text-center border-b border-[#E5E2DC]">
        <Reveal>
          <p className="font-display text-4xl sm:text-6xl font-light tracking-tight text-[#181817]">
            Noleggiamo e assistiamo <span className="text-[#C85A32]">tutti i modelli Canon.</span>
          </p>
        </Reveal>
      </section>
      <About />
      <Works />
      <ComeFunziona />
      <Services />
      <Faq />
      <Contacts />
    </main>
    <Footer />
    <QuoteModal />
    <B2BQuoteModal />
    <ChatWidget />
    <CookieBanner />
  </>
);

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (t) => {
      lenis.raf(t);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-[#FBF9F5] min-h-screen" data-testid="app-root">
      <Toaster position="bottom-center" toastOptions={{ style: { background: "#181817", color: "#FBF9F5", border: "none" } }} />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </BrowserRouter>
      <a
        data-testid="floating-whatsapp-button"
        href={CONTACTS.whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Scrivici su WhatsApp"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300"
      >
        <MessageCircle size={24} />
      </a>
    </div>
  );
}
